<template>
  <div class="login-cnt">
    <header>

    </header>
    <main>
      <h1 class="title">Global Ucenter 3.0(LLM)</h1>
      <div class="form">
        <h2 class="login-title">{{ $t("login.amount") }}</h2>
        <el-form class="form-cnt"
                 :model="ruleForm"
                 ref="ruleForm"
                 :rules="rules"
                 label-width="100px">
          <el-form-item label=""
                        prop="userName">
            <el-input type="text"
                      :maxlength="20"
                      v-model.trim="ruleForm.userName"
                      autocomplete="off"
                      :placeholder="$t('login.userName')"><template slot="prepend">
                <i class="el-icon-user-solid"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label=""
                        prop="pwd">
            <el-input type="password"
                      :maxlength="30"
                      v-model.trim="ruleForm.pwd"
                      autocomplete="off"
                      :placeholder="$t('login.passWord')"
                      show-password>
              <template slot="prepend">
                <i class="el-icon-lock"></i>
              </template>
            </el-input>
          </el-form-item>
          <el-form-item label=""
                        prop="googleKey">
            <el-input v-model.trim="ruleForm.googleKey"
                      :placeholder="$t('login.googleKey')">
              <template slot="prepend">
                <i class="iconfont icon-google0"
                   style="position: relative;top: 2px;"></i>
              </template>
            </el-input>
          </el-form-item>

          <el-form-item>
            <el-button type="primary"
                       @click="submitForm('ruleForm')"
                       :loading="loading"
                       style="width:100%;">{{ $t("login.submit") }}{{ loading ? "..." : "" }}</el-button>
          </el-form-item>
        </el-form>
        <p class="forget">
          <a :href="cnUrl"
             target="_blank">{{ $t("login.editPsd") }}</a>
        </p>
      </div>
    </main>
    <footer>
      <p>{{ $t("login.tips1") }}</p>
    </footer>
  </div>
</template>

<script>
import { mapMutations, mapGetters, mapActions } from "vuex";
import { login, userInfo } from "@/api/api.js";
import md5 from "js-md5";
export default {
  data() {
    const validateName = (rule, value, callback) => {
      if (value === "") {
        callback(new Error(this.$t("login.error1")));
      } else if (value.length > 20) {
        callback(new Error(this.$t("login.error2")));
      } else {
        callback();
      }
    };

    const validatePass = (rule, value, callback) => {
      // const pattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)[^]{12,30}$/;
      if (value === "") {
        callback(new Error(this.$t("login.error3")));
      }
      {
        callback();
      }
    };

    const checkKey = (rule, value, callback) => {
      if (!value) {
        return callback(new Error(this.$t("login.error5")));
      }

      if (!Number(value)) {
        callback(new Error(this.$t("login.error6")));
      }
      if (value.toString().length !== 6) {
        callback(new Error(this.$t("login.error6")));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        userName: "",
        pwd: "",
        googleKey: ""
      },
      rules: {
        userName: [{ validator: validateName, trigger: "blur" }],
        pwd: [{ validator: validatePass, trigger: "blur" }],
        googleKey: [{ validator: checkKey, trigger: "blur" }]
      },
      loading: false
    };
  },
  mounted() {
    // const _lang = this.lang;
    // this.language = _lang;
  },
  methods: {
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.login();
        } else {
          return false;
        }
      });
    },
    resetForm() {
      this.$refs["ruleForm"].resetFields();
    },
    async login() {
      this.loading = true;
      const params = {
        account: this.ruleForm.userName,
        pwd: md5(this.ruleForm.pwd.toString()),
        google_code: this.ruleForm.googleKey
      };
      try {
        await login(params);
        // const ifAuth = await getRouteList("zh_cn");
        // if (ifAuth.length === 0) {
        //   this.$message({
        //     message: this.$t("login.noPermission"),
        //     type: "warning"
        //   });
        //   this.loading = false;
        //   return;
        // }
        const info = await userInfo();
        await this.setUserInfo(info);
        this.loading = false;
        await this.$router.push({ path: "/homePage/memberList" }).catch(() => {
          this.$router.push({ path: "/homePage/memberList" });
        });
      } catch (error) {
        this.loading = false;
      }
    },
    ...mapMutations({
      setLang: "SET_SAVE_lang",
      setUserInfo: "SET_SAVE_userInfo"
    }),
    ...mapActions(["reset"])
  },
  computed: {
    ...mapGetters(["lang"]),
    cnUrl() {
      let host = window.location.hostname;
      if (/bom.uncle-delivery.com/.test(host)) {
        if (/-local|localhost|^192|^127|^172/.test(host)) {
          return "#";
        } else if (/-dev/.test(host)) {
          return "#";
        } else if (/-stg/.test(host)) {
          return "#";
        } else if (/-pre/.test(host)) {
          return "#";
        } else {
          return "https://ucenter.bom.uncle-delivery.com/#/changePwd";
        }
      } else if (/lalamove.com/.test(host)) {
        if (/-local|localhost|^192|^127|^172/.test(host)) {
          return "#";
        } else if (/-dev/.test(host)) {
          return "#";
        } else if (/-stg/.test(host)) {
          return "https://sg-ucenter-stg.lalamove.com/#/changepwd";
        } else if (/-pre/.test(host)) {
          return "#";
        } else {
          return "https://sg-ucenter.lalamove.com/#/changepwd";
        }
      }
      return "#";
    },
    language: {
      get: function () {
        return "en_us";
      },
      set: function (val) {
        this.resetForm();
        this.setLang(val);
        this.$i18n.locale = "en_us";
      }
    }
  }
};
</script>
<style>
.login-cnt .form-cnt .el-form-item__content {
  margin-left: 0 !important;
}
.login-cnt .form-cnt .el-input .el-input__inner {
  border-radius: 0;
}
.login-cnt .form-cnt .el-form-item__error {
  left: 55px;
  top: 90%;
}

/* .login-cnt ::-webkit-outer-spin-button,
.login-cnt ::-webkit-inner-spin-button {
  -webkit-appearance: none !important;
}
.login-cnt input[type="number"] {
  -moz-appearance: textfield !important;
} */
</style>
<style lang="less" scoped>
.login-cnt {
  width: 100%;
  height: 100%;
  background: #333a4d;
  header {
    height: 60px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    padding: 0 30px;
  }
  main {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    margin-top: 70px;
    .forget {
      text-align: right;
      a {
        color: #00a7f0;
      }
      font-size: 14px;
    }
  }
  .form {
    width: 360px;
    background: #fff;
    padding: 0px 20px 20px 20px;
    border-radius: 6px;
    .form-cnt {
      display: flex;
      flex-direction: column;
    }
  }
  .title {
    font-size: 30px;
    color: #fff;
    margin-bottom: 60px;
  }
  .login-title {
    font-size: 20px;
    color: #333;
    padding: 20px;
    text-align: center;
  }
  footer {
    margin-top: 30px;
    color: #fff;
    text-align: center;
    font-size: 16px;
    line-height: 1.5;
  }
}
</style>
